import { render, staticRenderFns } from "./UserInvitationForm.vue?vue&type=template&id=45863c12&scoped=true"
import script from "./UserInvitationForm.vue?vue&type=script&lang=js"
export * from "./UserInvitationForm.vue?vue&type=script&lang=js"
import style0 from "./UserInvitationForm.vue?vue&type=style&index=0&id=45863c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45863c12",
  null
  
)

export default component.exports